var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {}, [
    _c(
      "div",
      { staticClass: "navigation-group" },
      [
        _c(
          "router-link",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isMember,
                expression: "isMember",
              },
            ],
            attrs: {
              to: { name: "GoalDetailPageMainTasks", query: _vm.$route.query },
              replace: "",
            },
          },
          [
            _c("vue-folder-button", {
              attrs: {
                active: _vm.$route.name === "GoalDetailPageMainTasks",
                text: _vm.tasksLabel,
                "icon-class": "fa-tasks",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isMember,
                expression: "isMember",
              },
            ],
            attrs: {
              to: {
                name: "GoalDetailPageMainTimeline",
                query: _vm.$route.query,
              },
              replace: "",
            },
          },
          [
            _c("vue-folder-button", {
              attrs: {
                active: _vm.$route.name === "GoalDetailPageMainTimeline",
                text: "Timeline",
                "icon-class": "fa-clock-o",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            attrs: {
              to: { name: "GoalDetailPageMainAbout", query: _vm.$route.query },
              replace: "",
            },
          },
          [
            _c("vue-folder-button", {
              attrs: {
                active: _vm.$route.name === "GoalDetailPageMainAbout",
                text: "About",
                "icon-class": "fa-info",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.isMember &&
                  (!_vm.isShowMoreNeeded || _vm.showMorePressed),
                expression: "isMember&&(!isShowMoreNeeded||showMorePressed)",
              },
            ],
            attrs: {
              to: {
                name: "GoalDetailPageMainAttachments",
                query: _vm.$route.query,
              },
              replace: "",
            },
          },
          [
            _c("vue-folder-button", {
              attrs: {
                active: _vm.$route.name === "GoalDetailPageMainAttachments",
                text: "Attachments",
                "icon-class": "fa-file-text",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.isMember &&
                  (!_vm.isShowMoreNeeded || _vm.showMorePressed),
                expression: "isMember&&(!isShowMoreNeeded||showMorePressed)",
              },
            ],
            attrs: {
              to: {
                name: "GoalDetailPageMainMembers",
                query: _vm.$route.query,
              },
              replace: "",
            },
          },
          [
            _c("vue-folder-button", {
              attrs: {
                active: _vm.$route.name === "GoalDetailPageMainMembers",
                text: "Members",
                "icon-class": "fa-users",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("vue-folder-button", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowMoreNeeded,
              expression: "isShowMoreNeeded",
            },
          ],
          attrs: {
            text: "",
            "icon-class": "fa-ellipsis-h",
            color: "color-header",
            "inner-color": "#9c9c9c",
          },
          nativeOn: {
            click: function ($event) {
              return _vm.showMore.apply(null, arguments)
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "actions-group" },
      [
        _vm.filterAllowed
          ? _c("vue-folder-button", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.$route.name === "GoalDetailPageMainTasks",
                  expression: "$route.name==='GoalDetailPageMainTasks'",
                },
              ],
              attrs: {
                color: _vm.filterButtonColor,
                text: _vm.filterTasksLabel,
                "max-width": 100,
                "icon-class": "fa-filter",
                "no-text-on-mobile": true,
              },
              nativeOn: {
                click: function ($event) {
                  return _vm.editFilter.apply(null, arguments)
                },
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isFullScreenPossible
          ? _c("vue-folder-button", {
              attrs: {
                text: "Full Screen",
                "icon-class": "fa-expand-arrows-alt",
                "no-text-on-mobile": true,
              },
              nativeOn: {
                click: function ($event) {
                  return _vm.runFullscreen.apply(null, arguments)
                },
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isEditModePossible
          ? _c("vue-folder-button", {
              attrs: {
                text: _vm.editModeButtonLabel,
                "icon-class": _vm.editModeButtonClass,
                "no-text-on-mobile": true,
              },
              nativeOn: {
                click: function ($event) {
                  return _vm.toggleEditMode.apply(null, arguments)
                },
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.iCanMakeMeAdmin
          ? _c("vue-folder-button", {
              attrs: {
                text: "Make Me Admin",
                "icon-class": "fa-user-secret",
                "no-text-on-mobile": true,
              },
              nativeOn: {
                click: function ($event) {
                  return _vm.makeMeAdmin.apply(null, arguments)
                },
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("vue-folder-button", {
          attrs: {
            text: "Back",
            color: "blue",
            "icon-class": "fa-reply",
            "no-text-on-mobile": true,
          },
          nativeOn: {
            click: function ($event) {
              return _vm.goBack.apply(null, arguments)
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }